
export default function getShortenedSubstring(name, length, allowDots = true) {
    if (name) {
        return name.length < length
            ? name
            : `${name.substr(0, length)}${allowDots && "..."}`;
    }

    return "";
}